module.exports = __webpack_public_path__ + "static/media/Ufo.3c8666b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/themedEvent/Ufo.png
// module id = 1340
// module chunks = 3